import { Routes } from '@angular/router';

import { IndexComponent } from './pages/index/index.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SeasonResolver } from './shared/season-resource/season.resolver';

export const routes: Routes = [
  {
    path: 'season/:seasonId/create-presubscription',
    loadChildren: () =>
      import('./pages/create-presubscription/create-presubscription.routes').then(
        (m) => m.routes,
      ),
    resolve: {
      season: SeasonResolver,
    },
    providers: [SeasonResolver],
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./pages/contact/contact.routes').then((m) => m.routes),
  },
  // Routes critiques qui seront préchargées par CriticalPreloadingStrategy
  {
    path: 'presubscriptions',
    loadChildren: () =>
      import('./pages/presub/presubs.routes').then((m) => m.routes),
  },
  // Routes critiques qui seront préchargées par CriticalPreloadingStrategy
  {
    path: 'p',
    loadChildren: () =>
      import('./pages/presub/presubs.routes').then((m) => m.routes),
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./pages/user/user.routes').then((m) => m.routes),
  },
  {
    path: 'invoices',
    loadChildren: () =>
      import('./pages/invoices/invoices.routes').then((m) => m.routes),
  },
  {
    path: 'mes-recus-fiscaux',
    loadChildren: () =>
      import('./pages/my-cerfas/my-cerfas.routes').then((m) => m.routes),
  },
  {
    path: 'competitions',
    loadChildren: () =>
      import('./pages/competitions/competitions.routes').then((m) => m.routes),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.routes').then((m) => m.routes),
  },
  {
    path: '',
    pathMatch: 'full',
    component: IndexComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
